import { ActionType } from '../../classes/buytickets-actions';
import { IEventFilter } from '../../classes/buytickets';
import { IEvent } from '../../classes/event';
import { IShowPosterInfo } from '../../classes/showPosterInfo';

export function requestBuyTicketsEvents() {
    return {
        type: ActionType.RequestBuyTicketsEvents
    }
}

export function requestBuyTicketsShowPosterInfo() {
    return {
        type: ActionType.RequestBuyTicketsShowPosterInfo
    }
}

export function eventsUpdated() {
    return {
        type: ActionType.EventUpdated
    }
}

export function eventError(err: any) {
    return {
        type: ActionType.EventApiError,
        value: err
    }    
}

export function updateEvents(events: IEvent[]) {
    return {
        type: ActionType.UpdateEvents,
        value: events
    }
}

export function updateShowInfo(showPosterInfo: IShowPosterInfo) {
    return {
        type: ActionType.UpdateShowPosterInfo,
        value: showPosterInfo
    }
}

export function upsertEventFilter(filterFunction: IEventFilter) {
    return {
        type: ActionType.UpdateEventFilter,
        value: filterFunction
    }
}

export function removeEventFilter(filterKey: string) {
    return {
        type: ActionType.RemoveEventFilter,
        value: filterKey
    }
}

export function removeAllEventFilters() {
    return {
        type: ActionType.RemoveAllEventFilters
    }
}
